export const installments = {
    layout: {
        title: 'Parcelamentos',
        filtersTitle: 'Filtros',
        simulateTitle: 'Cabe mais uma?',
    },
    summary: {
        perMonth: 'Por mês',
        inMonth: 'Em {{month}}',
        monthBarAccessibility: '{{month}}, {{amount}} em parcelas',
        allSources: 'Todos os cartões e contas',
        incomeShare: '{{share}} da renda',
        remaining: 'Falta pagar',
        freeOf: 'Livre de parcelas',
        alreadyFree: 'já está',
    },
    list: {
        count_zero: 'Nenhum parcelamento',
        count_one: '{{count}} parcelamento',
        count_other: '{{count}} parcelamentos',
        sortedBy: 'Ordem: {{sort}}',
        perMonth: 'por mês',
        enteredIn: 'Entrou em {{month}}',
        startsIn: 'Começa em {{month}}',
        endsIn: 'acaba em {{month}}',
        paidOffIn: 'quitado em {{month}}',
        remaining: 'falta',
        total: 'total',
        badges: {
            done: 'Quitado',
            last: 'Última',
            new: 'Nova',
        },
        filterEmptyTitle: 'Nada com esses filtros',
        filterEmptySubtitle: 'Tente outro cartão ou um período maior.',
        clearFilters: 'Limpar filtros',
        monthEmptyTitle: 'Nenhuma parcela em {{month}}',
        allMonths: 'Ver todos os meses',
        emptyTitle: 'Nenhuma compra parcelada',
        emptySubtitle: 'Quando você parcelar no cartão ou na conta, as parcelas aparecem aqui, somadas mês a mês.',
        simulate: 'Simular nova compra',
        filtersAccessibility: 'Filtros',
        removeFilterAccessibility: 'Remover filtro: {{label}}',
        hiddenAmount: 'R$ ••••',
    },
    filters: {
        card: 'Cartão',
        allCards: 'Todos os cartões',
        account: 'Conta',
        allAccounts: 'Todas as contas',
        period: 'Compra entrou',
        status: 'Situação',
        sort: 'Ordenar',
        sortTitle: 'Ordenar por',
        clear: 'Limpar',
        purchases_one: '{{count}} compra',
        purchases_other: '{{count}} compras',
        viewCount_one: 'Ver {{count}} parcelamento',
        viewCount_other: 'Ver {{count}} parcelamentos',
        noResults: 'Nenhum resultado',
        periodTag: 'Entrou: {{period}}',
        monthTag: 'Parcelas de {{month}}',
        periods: {
            all: 'Qualquer data',
            thisMonth: 'Este mês',
            last3: 'Últimos 3 meses',
            last6: 'Últimos 6 meses',
            last12: 'Últimos 12 meses',
        },
        periodScope: {
            thisMonth: 'entrou este mês',
            last3: 'últimos 3 meses',
            last6: 'últimos 6 meses',
            last12: 'últimos 12 meses',
        },
        statuses: {
            open: 'Em andamento',
            last: 'Última parcela',
            done: 'Quitados',
            all: 'Todos',
        },
        sorts: {
            endsSoon: 'Acaba antes',
            recent: 'Mais recente',
            largest: 'Maior parcela',
            remaining: 'Falta pagar',
        },
    },
    simulate: {
        amountLabel: 'Valor da compra',
        card: 'Cartão',
        onAccount: 'Na conta',
        firstInstallment: '1ª parcela',
        firstInvoice: 'fatura de {{month}}',
        installments: 'Parcelas',
        optionAccessibility: '{{count}}x de {{amount}}',
        chartTitle: 'Parcelas por mês',
        legendCurrent: 'Atuais',
        legendNew: 'Nova',
        limitLabel: '{{percent}} da renda',
        chartNote: 'Só entram parcelas, de cartões e contas; as outras despesas, não. A linha é {{percent}} da média das suas receitas de {{from}} a {{to}}.',
        chartNoteNoIncome: 'Só entram parcelas, de cartões e contas; as outras despesas, não.',
        and: 'e',
        typeAmountTitle: 'Quanto custa a compra?',
        typeAmountBody: 'Digite o valor para ver como ela fica em cima das parcelas que você já tem.',
        planLine: '{{count}}x de {{amount}} até {{month}}.',
        whenList: 'em {{months}}',
        whenRange: 'de {{from}} a {{to}}',
        whenFrom: 'a partir de {{from}}',
        redTitle: 'Fica no vermelho {{when}}',
        redSuggestion: 'Em {{count}}x de {{amount}} o saldo previsto não fica negativo.',
        deeperTitle: 'Seu saldo previsto já fica negativo {{when}}',
        deeperBody: 'A compra deixa esses meses ainda mais no vermelho.',
        overTitle: 'Não fica no vermelho, mas passa de {{percent}} da renda {{when}}',
        incomeOverTitle: 'Passa de {{percent}} da renda {{when}}',
        overBody: 'Pico de parcelas de {{peak}} em {{peakMonth}}.',
        overSuggestion: 'Em {{count}}x de {{amount}} fica dentro dos {{percent}}.',
        noSuggestion: 'Parcelar em mais vezes, até 24x, não resolve.',
        fitsTitle: 'Cabe no saldo e na renda',
        fitsBalanceTitle: 'Cabe no saldo',
        incomeFitsTitle: 'Cabe: nenhum mês com a parcela nova passa de {{percent}} da renda',
        noIncomeNote: 'Sem receitas nos últimos 3 meses, não dá para comparar com a sua renda.',
        alreadyOver: 'Em {{months}}, as parcelas que você já tem passam da linha sozinhas.',
        balanceLabel: 'Saldo previsto em {{month}}',
        balanceLowestLabel: 'Saldo previsto no mês mais apertado, {{month}}',
        balanceNote: 'Saldo previsto: o disponível de hoje com as contas agendadas, as recorrências, as faturas e a média dos gastos do dia a dia.',
        trySuggestion: 'Ver em {{count}}x',
        noIncomeTitle: 'Com ela, o mês mais pesado fica em {{peak}}',
        noIncomeBody: 'Sem receitas lançadas nos últimos 3 meses, ainda não dá para comparar com a sua renda. {{count}}x de {{amount}} até {{month}}.',
        chartAccessibility: 'Gráfico das parcelas dos próximos 12 meses com a compra simulada',
    },
    teaser: {
        title: 'Todas as parcelas num lugar só',
        subtitle: 'Quanto falta, quando a fatura alivia e se cabe mais uma compra, somando seus cartões e contas.',
        cta: 'Desbloquear Parcelamentos',
    },
};
